import { Component } from '@verndale/core';
import Headroom from 'headroom.js';
import MakeHeaderAccessible from './make-header-accessible';
import FindACommunityHeader from './find-a-community-header';
import HamburgerMenu from './hamburger-menu';
import debounce from 'lodash.debounce';
import { isEmpty } from '../helpers';
import { BREAKPOINTS } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $header: this.el,
      $hamburger: this.el._$('.header__hamburger'),
      $hamburgerMenu: this.el._$('#hmenu'),
      $hamburgerMenuBanner: this.el._$('.hamburger-menu-banner'),
      $hamburgerMenuItemTitles: this.el._$$('.hamburger-menu__title-label'),
      $topLevelNavs: this.el._$('.header__top-level-navs'),
      $childNavWrapper: this.el._$('.header__child-nav-wrapper'),
      $closeHamburger: this.el._$('.header__close'),
      $careersTrigger: this.el._$('.careers-header-trigger'),
      $campaignPhone: this.el._$('.campaign-phone'),
      $headerlogo: this.el._$('.header__logo'),
      $headerPanel: this.el._$('.header__panel'),
      $utilityLinks: this.el._$('.header-utility-links'),
      $closeChildNavTrigger: this.el._$('.header__back-to-top-level-trigger'),
      $primaryNavPanels: this.el._$$('.primary-nav__child-menu')
    };

    this.panelOpenedClass = 'header--panel-opened';
    this.childMenuPanelOpenedClass = 'header--child-menu-panel-opened';
    this.expandedPrimaryNavItemClass = 'primary-nav__item--expanded';
    this.openedPrimaryNavChildMenuClass = 'primary-nav__child-menu--opened';
    this.desktopMediaQuery = window.matchMedia('(min-width: 1200px)');
    this.isFullNav = this.desktopMediaQuery.matches;
    this.isDesktop = this.isFullNav;

    this.expanded = false;

    this.isCampaignHeader = this.el.classList.contains('campaign-header');

    this.breakpointDesktop = window.matchMedia(`(max-width: ${BREAKPOINTS.DESKTOP - 1}px)`);
    this.breakpointWide = window.matchMedia(`(max-width: ${BREAKPOINTS.WIDE - 1}px)`);
    this.breakpointExtraWide = window.matchMedia(`(min-width: ${BREAKPOINTS.EXTRA_WIDE - 80}px)`);

    this.setup();
    this.stick();
    this.initSubModules();
    this.renderMobileOptions();

    if (!this.isCampaignHeader && isEmpty(this.dom.$hamburgerMenuBanner)) {
      this.el._$$('.hamburger-menu-banner').forEach(el => {
        el.hidden = true;
      });
    }
  }

  addListeners() {
    this.dom.$hamburger?._on('click', this.handleHamburgerClick.bind(this));
    this.dom.$closeHamburger?._on(
      'click',
      this.handleCloseHamburgerClick.bind(this)
    );
    this.dom.$primaryNavTriggers?._on(
      'mouseup',
      this.handlePrimaryNavTriggerClick.bind(this)
    );
    this.dom.$closeChildNavTrigger?._on(
      'click',
      this.handleCloseChildNavTriggerClick.bind(this)
    );
    this.desktopMediaQuery.addEventListener('change', e => {
      this.isFullNav = e.matches;
    });
    window.addEventListener(
      'resize',
      debounce(this.renderMobileOptions.bind(this), 300)
    );
  }

  setup() {
    this.renderPrimaryNavTopLevelItems();
    this.renderHamburgerMenuInsideHamburgerNav();
    this.el.classList.add('header--loaded');
  }

  scrollToHeader() {
    const topScrollPros = document.documentElement.scrollTop;
    const headerScrollPos = this.el.getBoundingClientRect().top + topScrollPros;
    if (topScrollPros < headerScrollPos) {
      window.scrollTo({ top: headerScrollPos, behavior: 'smooth' });
    }
  }

  lockScroll() {
    _$('html, body').style.overflow = 'hidden';
  }

  unlockScroll() {
    _$('html, body').style.overflow = 'visible';
  }

  stick() {
    this.el.classList.add('sticky--header')
    new Headroom(this.el, {
      offset: this.el.offsetTop,
      classes: {
        initial: 'header',
        pinned: 'header--visible',
        top: '-',
        notTop: '-',
        bottom: '-',
        notBottom: '-',
        frozen: '-'
      },
      onPin: () => {
        document.body.classList.add('header--visible');
        document.body.classList.remove('header--hidden');
      },
      onUnpin: () => {
        document.body.classList.add('header--hidden');
        document.body.classList.remove('header--visible');
      }
    }).init();
  }

  openPrimaryNavChildMenu() {
    this.el.classList.add(this.childMenuPanelOpenedClass);

    if (this.isFullNav) {
      document._on(
        'mousedown',
        this.handleListenToOutsidePrimaryNavPanel.bind(this)
      );
    }
  }

  closePrimaryNavChildMenu() {
    this.el.classList.remove(this.childMenuPanelOpenedClass);
    this.dom.$primaryNavItems
      .find(el => el.classList.contains(this.expandedPrimaryNavItemClass))
      ?.classList.remove(this.expandedPrimaryNavItemClass);
    this.communityOrTour.focusOut();
    document.removeEventListener(
      'click',
      this.handleListenToOutsidePrimaryNavPanel.bind(this)
    );
  }

  displayPrimaryNavPanel(id) {
    const panel = this.dom.$primaryNavPanels.find(el => el.id === id);

    const itemRect = this.el._$(`[data-panel='${id}']`);
    let triggerPos = 0;

    if (itemRect && itemRect.getBoundingClientRect() && this.isDesktop) {
      triggerPos = itemRect.getBoundingClientRect().left - 10;
    }

    this.dom.$childNavWrapper.style.left = `${triggerPos}px`;

    this.dom.$primaryNavPanels.forEach(el => {
      el.classList.remove(this.openedPrimaryNavChildMenuClass);
    });

    panel?.classList?.add?.(this.openedPrimaryNavChildMenuClass);

    return panel;
  }

  focusOutPrimaryNav() {
    this.dom.$primaryNavItems.forEach(el =>
      el.classList.remove(this.expandedPrimaryNavItemClass)
    );
  }

  initSubModules() {
    new MakeHeaderAccessible({
      dom: this.dom,
      handlePrimaryNavTriggerClick:
        this.handlePrimaryNavTriggerClick.bind(this),
      closePrimaryNavChildMenu: this.closePrimaryNavChildMenu.bind(this)
    });

    const commonConfig = {
      dom: this.dom,
      openPrimaryNavChildMenu: this.openPrimaryNavChildMenu.bind(this),
      closePrimaryNavChildMenu: this.closePrimaryNavChildMenu.bind(this),
      displayPrimaryNavPanel: this.displayPrimaryNavPanel.bind(this),
      focusOutPrimaryNav: this.focusOutPrimaryNav.bind(this)
    };

    if (!this.isCampaignHeader) {
      this.hamburgerMenu = new HamburgerMenu(commonConfig);
      this.communityOrTour = new FindACommunityHeader(commonConfig);
    }
  }

  renderPrimaryNavTopLevelItems() {
    const list = document.createElement('ul');
    list.role = 'menubar';
    list.classList.add('primary-nav');

    const items = this.dom.$primaryNavPanels
      .map((panel, i) => {

        const $link = panel._$('.primary-nav__child-menu-title');
        const link = $link?.textContent;

        if (!link) return '';

        return `
        <li class="primary-nav__item">
          ${!$link.href ? `<button
            class="primary-nav__trigger header__mobile-sub-panel-trogger"
            aria-haspopup="true"
            aria-expanded="false"
            data-panel="${panel.id}"
            tabindex="${i ? '-1' : 0}"
          >
            ${link}
            <svg class="primary-nav__trigger-arrow--down" width="18" height="11" viewBox="0 0 18 11" aria-hidden="true"><use xlink:href="#arrow-down" /></svg>
            <svg class="primary-nav__trigger-arrow--right" width="11" height="18" viewBox="0 0 11 18" aria-hidden="true"><use xlink:href="#arrow-right" /></svg>
          </button>
          ` : `
          <a
            class="primary-nav__trigger header__mobile-sub-panel-trogger"
            data-panel="${panel.id}"
            href="${link.href}"
            tabindex="${i ? '-1' : 0}"
          >
            ${link}
          </a>
          `}
        </li>
      `;
      })
      .join('');

    list.innerHTML = items;
    this.dom.$topLevelNavs.prepend(list);

    this.dom.$primaryNavItems = this.el._$$('.primary-nav__item');
    this.dom.$primaryNavTriggers = this.el._$$('.primary-nav__trigger');
  }

  renderMobileOptions() {
    this.isDesktop = this.isFullNav;

    if (!this.isDesktop) {
      this.dom.$headerlogo.parentNode.insertBefore(
        this.dom.$careersTrigger,
        this.dom.$headerPanel
      );
      if (this.isCampaignHeader) {
        this.dom.$headerlogo.parentNode.insertBefore(
          this.dom.$campaignPhone,
          this.dom.$careersTrigger
        );
        this.dom.$headerlogo.parentNode.insertBefore(
          this.dom.$utilityLinks,
          this.dom.$careersTrigger
        );
      }
    } else {
      if (this.isCampaignHeader) {
        this.dom.$topLevelNavs.append(this.dom.$campaignPhone);
        this.dom.$topLevelNavs.append(this.dom.$utilityLinks);
      }
      this.dom.$topLevelNavs.append(this.dom.$careersTrigger);
    }
  }

  renderHamburgerMenuInsideHamburgerNav() {
    const banner = document.createElement('div');
    if (this.dom.$hamburgerMenuBanner) {
      banner.classList.add('hamburger-menu-banner');
      banner.innerHTML = this.dom.$hamburgerMenuBanner.innerHTML;
    }
    this.dom.$hamburgerMenu?.prepend(banner);
  }

  handleHamburgerClick() {
    this.expanded = !this.expanded;
    this.dom.$hamburger.setAttribute('aria-expanded', this.expanded);

    this.el.classList.add(this.panelOpenedClass);
    this.lockScroll();
    this.scrollToHeader();

    this.dom.$hamburgerMenu.focus();
  }

  handleCloseHamburgerClick() {
    this.expanded = !this.expanded;
    this.dom.$hamburger.setAttribute('aria-expanded', this.expanded);

    this.el.classList.remove(this.panelOpenedClass);
    this.unlockScroll();
    this.closePrimaryNavChildMenu();
    this.displayPrimaryNavPanel();
  }

  handlePrimaryNavTriggerClick(e) {
    const item = e.target.closest('.primary-nav__item');
    const id = e.target.dataset.panel;
    this.focusOutPrimaryNav();
    this.communityOrTour.focusOut();

    if (this.el.classList.contains(this.childMenuPanelOpenedClass)) {
      this.closePrimaryNavChildMenu();
      return;
    }

    item.classList.add(this.expandedPrimaryNavItemClass);

    this.openPrimaryNavChildMenu();
    return this.displayPrimaryNavPanel(id);
  }

  handleCloseChildNavTriggerClick() {
    this.closePrimaryNavChildMenu();
  }

  handleListenToOutsidePrimaryNavPanel(e) {
    const hasClickedOutSidePanel = !this.dom.$childNavWrapper.contains(
      e.target
    );
    const hasClickedPrimaryNavTrigger = this.dom.$primaryNavTriggers.find(el =>
      el.contains(e.target)
    );
    const hasClickedcareersTrigger = this.dom.$careersTrigger?.contains?.(
      e.target
    );

    if (
      hasClickedOutSidePanel &&
      !hasClickedPrimaryNavTrigger &&
      !hasClickedcareersTrigger
    ) {
      this.closePrimaryNavChildMenu();
    }
  }
}

export default Module;
